:host {
  display: inline-flex;
  box-sizing: border-box;
  gap: var(--spacer-2);
  align-items: baseline;
  text-align: left;
}
.color {
  width: 1.5ex;
  aspect-ratio: 1 / 1;
  box-shadow: 0 0 0 1px rgba(var(--theme-rgb-primary-background), 0.3);
  border-radius: 50%;
}
#date {
  white-space: nowrap;
}
